const Wishlist = {
  apiUrl: 'https://personalizepharma.duo.studio',
  remoteSyncEnabled: false,
  items: [],
  storageKey: 'WISHLIST',
  customerId: window.customerId,
  async init() {
    if (!Wishlist.customerId) {
      console.info('Wishlist: usuário não logado');
      return;
    }

    const cached = localStorage.getItem(Wishlist.storageKey);
    Wishlist.items = cached ? JSON.parse(cached) : [];

    const wishlistButtons = document.querySelectorAll('.wishlist-btn');

    wishlistButtons.forEach(button => {
      button.addEventListener('click', Wishlist.handleWishlistButtonClick);
    });

    document.addEventListener('wishlist:updated', (event) => {
      Wishlist.updateAllButtonStates();
    });

    Wishlist.updateAllButtonStates();
  },

  async getWishlist() {
    const cachedWishlist = localStorage.getItem(Wishlist.storageKey);
    if (cachedWishlist) return JSON.parse(cachedWishlist)

    if (!Wishlist.remoteSyncEnabled) return [];

    const response = await fetch(`${Wishlist.apiUrl}/api/wishlist/${Wishlist.customerId}`)
    const data = await response.json();
    localStorage.setItem(Wishlist.storageKey, JSON.stringify(data.wishlist));
    
    return data.wishlist;
  },

  async addProduct(productId) {
    if (!Wishlist.items.includes(productId)) {
      Wishlist.items.push(productId);
      localStorage.setItem(Wishlist.storageKey, JSON.stringify(Wishlist.items));
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { wishlist: Wishlist.items } }));

      if (!Wishlist.remoteSyncEnabled) return Wishlist.items;

      try {
        const response = await fetch(`${Wishlist.apiUrl}/api/wishlist/add`, {
          headers: { 'Content-Type': 'application/json' },
          method: 'POST',
          body: JSON.stringify({ customerId: Wishlist.customerId, productId }),
        });
        const data = await response.json();
        localStorage.setItem(Wishlist.storageKey, JSON.stringify(data.wishlist));
        return data.wishlist;
      } catch (err) {
        console.warn('Wishlist: falha ao sincronizar adição com API.', err);
      }
    }
  },

  async removeProduct(productId) {
    const newWishlist = Wishlist.items.filter(id => id !== productId);
    Wishlist.items = newWishlist;
    localStorage.setItem(Wishlist.storageKey, JSON.stringify(Wishlist.items));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { wishlist: Wishlist.items } }));

    if (!Wishlist.remoteSyncEnabled) return Wishlist.items;

    try {
      const response = await fetch(`${Wishlist.apiUrl}/api/wishlist/remove`, {
        headers: { 'Content-Type': 'application/json' },
        method: 'DELETE',
        body: JSON.stringify({ customerId: Wishlist.customerId, productId }),
      });
      const data = await response.json();
      localStorage.setItem(Wishlist.storageKey, JSON.stringify(data.wishlist));
      return data.wishlist;
    } catch (err) {
      console.warn('Wishlist: falha ao sincronizar remoção com API.', err);
    }
  },

  isInWishlist(productId) {
    return Wishlist.items.includes(productId);
  },

  updateAllButtonStates() {
    const buttons = document.querySelectorAll('.wishlist-btn');
    buttons.forEach(button => {
      const productId = button.dataset.productId;
      if (Wishlist.isInWishlist(productId)) {
        button.classList.add('active');
        button.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M2 8.5C2 5.46243 4.46243 3 7.5 3C9.36016 3 11.0046 3.92345 12 5.33692C12.9954 3.92345 14.6398 3 16.5 3C19.5376 3 22 5.46243 22 8.5C22 16 11.9999 21.4852 11.9999 21.4852C11.9999 21.4852 2 16 2 8.5Z"></path>
            </svg>
        `
      } else {
        button.classList.remove('active');
        button.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 8.81056L13.6352 6.48845C14.2721 5.58412 15.3179 5 16.5 5C18.433 5 20 6.567 20 8.5C20 11.3788 18.0407 14.1215 15.643 16.3358C14.4877 17.4027 13.3237 18.2603 12.4451 18.8521C12.2861 18.9592 12.1371 19.0571 11.9999 19.1456C11.8627 19.0571 11.7137 18.9592 11.5547 18.8521C10.6761 18.2604 9.51216 17.4028 8.35685 16.3358C5.95926 14.1216 4 11.3788 4 8.5C4 6.567 5.567 5 7.5 5C8.68209 5 9.72794 5.58412 10.3648 6.48845L12 8.81056ZM10.5557 3.92626C9.68172 3.3412 8.63071 3 7.5 3C4.46243 3 2 5.46243 2 8.5C2 16 11.9999 21.4852 11.9999 21.4852C11.9999 21.4852 22 16 22 8.5C22 5.46243 19.5376 3 16.5 3C15.3693 3 14.3183 3.3412 13.4443 3.92626C12.8805 4.3037 12.3903 4.78263 12 5.33692C11.6097 4.78263 11.1195 4.3037 10.5557 3.92626Z"></path>
            </svg>
        `
      }
    });
  },

  handleWishlistButtonClick(event) {
    const button = event.currentTarget;
    const productId = button.dataset.productId;

    if (!productId) {
      console.error('Botão da wishlist não tem o atributo data-product-id.');
      return;
    }

    if (Wishlist.isInWishlist(productId)) {
      Wishlist.removeProduct(productId);
    } else {
      Wishlist.addProduct(productId);
    }
  }
}


document.addEventListener('DOMContentLoaded', () => {
  Wishlist.init();
});
